import { GameState } from "../enum/GameState";
import { PacketValueSerialType } from "../enum/PacketValueSerialType";
import { PlayerClassType } from "../enum/PlayerClassType";
import { Input } from "../lib/Input";
import NetworkBehavior from "../lib/NetworkBehavior";
import { Time } from "../lib/Time";
import { Physics } from "../math/Physics";
import Vector2 from "../math/Vector2";
import { formatTime, formatTimeToMinutes } from "../util";
import { Random } from "../util/Random";
import { Shapes } from "../util/Shapes";
import Player from "./Player";

export default class GameManager extends NetworkBehavior {

    static Singleton: GameManager|undefined = undefined;

    // static spawns = {
    //     red: new Vector2(-10000, -10000),
    //     blue: new Vector2(-9744, -10000)
    // }
    static spawns = {
        red: new Vector2(-2964, 3428),
        blue: new Vector2(2765, -3204)
    }

    static matchLength = 600;

    static GetSpawn(team: "red"|"blue") {
        const spawn = this.spawns[team];

        return spawn.add(new Vector2(Random.int(-128, 128), Random.int(-128, 128)));
    }

    static buttons = {
        joinTeamRed: {
            center: Vector2.zero,
            size: new Vector2(70, 20)
        },
        joinTeamBlue: {
            center: Vector2.zero,
            size: new Vector2(70, 20)
        },
        startGame: {
            center: Vector2.zero,
            size: new Vector2(70, 20)
        },
        pickFighter: {
            center: Vector2.zero,
            size: new Vector2(18, 18)
        },
        pickTank: {
            center: Vector2.zero,
            size: new Vector2(18, 18)
        },
        pickSniper: {
            center: Vector2.zero,
            size: new Vector2(18, 18)
        },
        pickScout: {
            center: Vector2.zero,
            size: new Vector2(18, 18)
        },
        pickHealer: {
            center: Vector2.zero,
            size: new Vector2(18, 18)
        }
    };

    private gameState: GameState = GameState.Lobby;
    getGameState() {return this.gameState;}
    setGameState(state: GameState) {

        switch (state) {
            case GameState.InGame:
                this.gameTimer = GameManager.matchLength;
                break;
        
            default:
                break;
        }

        this.gameState = state;
    }

    private uiImg: HTMLImageElement = document.querySelector("img#ui") as HTMLImageElement;
    private abilityIconsImg: HTMLImageElement = document.querySelector("img#ability_icons") as HTMLImageElement;

    score = {
        red: 0,
        blue: 0
    };

    gameTimer = GameManager.matchLength;
    postGameTimer = 5;

    StartGame() {
        this.setGameState(GameState.InGame);


        for (const player of this.engine.GetGameObjectsBehaviors<Player>(Player)) {
            if (!player.team) continue;

            const spawn = GameManager.GetSpawn(player.team);
            player.transform.position = spawn.clone();
            
            this.engine.sendUpdateTransformPacket(player.gameObject);
        }
    }

    Init(): void {
        if (GameManager.Singleton == undefined) {
            GameManager.Singleton = this;
            this.gameObject.layer = 1;
        } else if (GameManager.Singleton.id !== this.id) {
            this.gameObject.RemoveScript(this.id);
        }
    }

    LobbyUpdate() {
        if (!this.engine.clientPlayer) return;

        if (Input.GetMouseButtonDown(0)) {

            for (const key in GameManager.buttons) {
                //@ts-ignore
                const button: Shapes.Rect = GameManager.buttons[key];

                if (Physics.PointInRect(Input.mousePosition, button)) {
                    switch (key) {
                        case "joinTeamRed":
                            this.engine.clientPlayer.team = "red";
                            this.engine.sendUpdatePacket(this.engine.clientPlayer, "PLAYER", [
                                {
                                    key: "team",
                                    value: "red",
                                    type: PacketValueSerialType.String
                                }
                            ]);
                            break;
                        case "joinTeamBlue":
                            this.engine.clientPlayer.team = "blue";
                            this.engine.sendUpdatePacket(this.engine.clientPlayer, "PLAYER", [
                                {
                                    key: "team",
                                    value: "blue",
                                    type: PacketValueSerialType.String
                                }
                            ]);
                            break;
                        case "startGame":
                            if (this.isHost) {
                                this.StartGame();
                            }
                            break;
                        case "pickFighter":
                            this.engine.clientPlayer?.SetClass(PlayerClassType.Fighter);
                            break;
                        case "pickTank":
                            this.engine.clientPlayer?.SetClass(PlayerClassType.Tank);
                            break;
                        case "pickSniper":
                            this.engine.clientPlayer?.SetClass(PlayerClassType.Sniper);
                            break;
                        case "pickScout":
                            this.engine.clientPlayer?.SetClass(PlayerClassType.Scout);
                            break;
                        case "pickHealer":
                            this.engine.clientPlayer?.SetClass(PlayerClassType.Healer);
                            break;
                    
                        default:
                            break;
                    }
                }
            }

        }
    }

    InGameUpdate() {
        if (!this.isHost) return;

        this.gameTimer -= Time.deltaTime;

        if (this.gameTimer <= 0) {
            this.gameTimer = 0;
            this.setGameState(GameState.PostGame);
        }
    }

    PostGameUpdate() {
        if (!this.isHost) return;

        this.postGameTimer -= Time.deltaTime;

        if (this.postGameTimer <= 0) {
            this.postGameTimer = 5;
            this.setGameState(GameState.Lobby);
            this.score.red = 0;
            this.score.blue = 0;
            this.gameTimer = GameManager.matchLength;
        }
    }

    Update(): void {

        switch (this.gameState) {
            case GameState.Lobby:
                this.LobbyUpdate();
                break;
            case GameState.InGame:
                this.InGameUpdate();
                break;
            case GameState.PostGame:
                this.PostGameUpdate();
                break;
        
            default:
                break;
        }
    }

    LateUpdate(): void {
        if (!this.isHost) return;

        this.engine.sendUpdatePacket(this, "GAME_MANAGER", [
            {
                key: "gameState",
                value: this.gameState,
                type: PacketValueSerialType.Byte
            },
            {
                key: "score",
                value: this.score,
                type: PacketValueSerialType.Scores
            },
            {
                key: "gameTimer",
                value: this.gameTimer,
                type: PacketValueSerialType.Float
            },
            {
                key: "postGameTimer",
                value: this.postGameTimer,
                type: PacketValueSerialType.Float
            }
        ]);
    }

    DrawUiIcon(index: number, position: Vector2) {
        const sx = (index % (this.uiImg.width/18)) * 18;
        const sy = Math.floor(index/(this.uiImg.width/18)) * 18;
        this.ctx.drawImage(this.uiImg, sx, sy, 18, 18, position.x - 9, position.y - 9, 18, 18);
    }

    DrawAbilityIcon(index: number, position: Vector2) {
        const sx = (index % (this.abilityIconsImg.width/32)) * 32;
        const sy = Math.floor(index/(this.abilityIconsImg.width/32)) * 32;
        this.ctx.drawImage(this.abilityIconsImg, sx, sy, 32, 32, position.x - 16, position.y - 16, 32, 32);
    }


    DrawInGameScreen() {
        this.ctx.lineWidth = 1;
        this.ctx.strokeStyle = 'red';
        this.engine.StrokeCircle(GameManager.spawns['red'], 64);
        this.ctx.strokeStyle = 'blue';
        this.engine.StrokeCircle(GameManager.spawns['blue'], 64);

        const scoreboardDrawPos = new Vector2(this.engine.center.x, 12);
        this.ctx.fillStyle = '#101010';
        this.engine.FillRectScreenFromCenter(scoreboardDrawPos, new Vector2(68, 24));
        this.ctx.fillStyle = 'red';
        this.engine.FillRectScreenFromCenter(scoreboardDrawPos.add(Vector2.left.scale(44)), new Vector2(24, 24));
        this.ctx.fillStyle = 'blue';
        this.engine.FillRectScreenFromCenter(scoreboardDrawPos.add(Vector2.right.scale(44)), new Vector2(24, 24));

        this.engine.drawTexts([`${formatTimeToMinutes(this.gameTimer)}`], scoreboardDrawPos, {
            align: "center",
            baseline: "middle",
            color: 'white',
            size: 24
        });

        this.engine.drawTexts([`${this.score.red}`], scoreboardDrawPos.add(Vector2.left.scale(44)), {
            align: "center",
            baseline: "middle",
            color: 'black',
            size: 24
        });
        this.engine.drawTexts([`${this.score.blue}`], scoreboardDrawPos.add(Vector2.right.scale(44)), {
            align: "center",
            baseline: "middle",
            color: 'black',
            size: 24
        });
    }

    DrawPostGameScreen() {
        const winner = this.score.red === this.score.blue ? "Tie" : this.score.red > this.score.blue ? "Red": "Blue";
        this.ctx.fillStyle = this.score.red === this.score.blue ? "white" : this.score.red > this.score.blue ? "red" : "blue";

        this.engine.drawTexts([
            winner === "Tie" ? "It's a tie!" : `${winner} wins!`
        ], this.engine.center.add(Vector2.up.scale(16)), {
            align: "center",
            baseline: "bottom",
            size: 64
        });

        this.engine.FillRectScreenFromCenter(this.engine.center.add(Vector2.up.scale(16)), new Vector2(this.engine.width/2 * (this.postGameTimer/5), 1));
    }

    DrawLobbyScreen() {
        const winSize = new Vector2(
            this.engine.width - 20,
            this.engine.height - 20
        );
        this.ctx.fillStyle = '#55ff55';
        this.engine.FillRectScreenFromCenter(this.engine.center, new Vector2(
            this.engine.width - 16,
            this.engine.height - 16
        ));
        this.ctx.fillStyle = 'black';
        this.engine.FillRectScreenFromCenter(this.engine.center, winSize);

        const winTopLeft = this.engine.center.sub(winSize.scale(0.5));

        this.ctx.fillStyle = '#ff000010';
        this.ctx.fillRect(winTopLeft.x, winTopLeft.y, winSize.x/2, winSize.y);
        this.ctx.fillStyle = '#0000ff10';
        this.ctx.fillRect(winTopLeft.x + winSize.x/2, winTopLeft.y, winSize.x/2, winSize.y);

        this.ctx.fillStyle = '#55ff55';
        const redTxtPos = winTopLeft.add(new Vector2(winSize.x/4, 48));
        const blueTxtPos = winTopLeft.add(new Vector2(winSize.x/2 + winSize.x/4, 48));

        const redPlayers = this.engine.GetGameObjectsBehaviors<Player>(Player).filter(v => v.team === "red");
        const bluePlayers = this.engine.GetGameObjectsBehaviors<Player>(Player).filter(v => v.team === "blue");

        this.engine.drawTexts(
            [
                `Red Team`,
                ...redPlayers.map(v => v.name)
            ],
            redTxtPos,
            {
                align: 'center'
            }
        );

        for (let i = 0; i < redPlayers.length; i++) {
            const player = redPlayers[i];
            this.DrawUiIcon(player.class?.type ?? 0, redTxtPos.add(new Vector2(-64, 16*(i+1)+4)));
        }

        GameManager.buttons.joinTeamRed.center = redTxtPos.add(Vector2.up.scale(GameManager.buttons.joinTeamRed.size.y));
        this.engine.FillRectScreenFromCenter(GameManager.buttons.joinTeamRed.center, GameManager.buttons.joinTeamRed.size);
        this.engine.drawTexts(['Join Red Team'], GameManager.buttons.joinTeamRed.center, {
            align: "center",
            baseline: "middle",
            color: "black"
        });

        

        this.engine.drawTexts(
            [
                `Blue Team`,
                ...bluePlayers.map(v => v.name)
            ],
            blueTxtPos,
            {
                align: 'center'
            }
        );

        for (let i = 0; i < bluePlayers.length; i++) {
            const player = bluePlayers[i];
            this.DrawUiIcon(player.class?.type ?? 0, blueTxtPos.add(new Vector2(64, 16*(i+1)+4)));
        }

        GameManager.buttons.joinTeamBlue.center = blueTxtPos.add(Vector2.up.scale(GameManager.buttons.joinTeamBlue.size.y));
        this.engine.FillRectScreenFromCenter(GameManager.buttons.joinTeamBlue.center, GameManager.buttons.joinTeamBlue.size);
        this.engine.drawTexts(['Join Blue Team'], GameManager.buttons.joinTeamBlue.center, {
            align: "center",
            baseline: "middle",
            color: "black"
        });

        const drawClassesPos = new Vector2(winTopLeft.x + winSize.x/2, winTopLeft.y + winSize.y - 80);

        GameManager.buttons.pickSniper.center = drawClassesPos.clone();
        GameManager.buttons.pickTank.center = GameManager.buttons.pickSniper.center.add(Vector2.left.scale(32));
        GameManager.buttons.pickFighter.center = GameManager.buttons.pickTank.center.add(Vector2.left.scale(32));
        GameManager.buttons.pickScout.center = GameManager.buttons.pickSniper.center.add(Vector2.right.scale(32));
        GameManager.buttons.pickHealer.center = GameManager.buttons.pickScout.center.add(Vector2.right.scale(32));

        this.ctx.fillStyle = '#55ff5555';
        this.ctx.strokeStyle = '#ffff55';
        this.ctx.lineWidth = 1;

        if (Physics.PointInRect(Input.mousePosition, GameManager.buttons.pickFighter) || this.engine.clientPlayer?.class?.type === PlayerClassType.Fighter) {
            this.engine.FillRectScreenFromCenter(GameManager.buttons.pickFighter.center, GameManager.buttons.pickFighter.size.add(new Vector2(2, 2)));
            this.engine.StrokeRectScreenFromCenter(GameManager.buttons.pickFighter.center, GameManager.buttons.pickFighter.size.add(new Vector2(2, 2)));
        }
        if (Physics.PointInRect(Input.mousePosition, GameManager.buttons.pickTank) || this.engine.clientPlayer?.class?.type === PlayerClassType.Tank) {
            this.engine.FillRectScreenFromCenter(GameManager.buttons.pickTank.center, GameManager.buttons.pickTank.size.add(new Vector2(2, 2)));
            this.engine.StrokeRectScreenFromCenter(GameManager.buttons.pickTank.center, GameManager.buttons.pickTank.size.add(new Vector2(2, 2)));
        }
        if (Physics.PointInRect(Input.mousePosition, GameManager.buttons.pickSniper) || this.engine.clientPlayer?.class?.type === PlayerClassType.Sniper) {
            this.engine.FillRectScreenFromCenter(GameManager.buttons.pickSniper.center, GameManager.buttons.pickSniper.size.add(new Vector2(2, 2)));
            this.engine.StrokeRectScreenFromCenter(GameManager.buttons.pickSniper.center, GameManager.buttons.pickSniper.size.add(new Vector2(2, 2)));
        }
        if (Physics.PointInRect(Input.mousePosition, GameManager.buttons.pickScout) || this.engine.clientPlayer?.class?.type === PlayerClassType.Scout) {
            this.engine.FillRectScreenFromCenter(GameManager.buttons.pickScout.center, GameManager.buttons.pickScout.size.add(new Vector2(2, 2)));
            this.engine.StrokeRectScreenFromCenter(GameManager.buttons.pickScout.center, GameManager.buttons.pickScout.size.add(new Vector2(2, 2)));
        }
        if (Physics.PointInRect(Input.mousePosition, GameManager.buttons.pickHealer) || this.engine.clientPlayer?.class?.type === PlayerClassType.Healer) {
            this.engine.FillRectScreenFromCenter(GameManager.buttons.pickHealer.center, GameManager.buttons.pickHealer.size.add(new Vector2(2, 2)));
            this.engine.StrokeRectScreenFromCenter(GameManager.buttons.pickHealer.center, GameManager.buttons.pickHealer.size.add(new Vector2(2, 2)));
        }

        this.DrawUiIcon(0, GameManager.buttons.pickFighter.center);
        this.DrawUiIcon(1, GameManager.buttons.pickTank.center);
        this.DrawUiIcon(2, GameManager.buttons.pickSniper.center);
        this.DrawUiIcon(3, GameManager.buttons.pickScout.center);
        this.DrawUiIcon(4, GameManager.buttons.pickHealer.center);

        this.engine.drawTexts(
            [
                `${this.engine.clientPlayer?.class ? PlayerClassType[this.engine.clientPlayer.class.type] : ''}`
            ],
            GameManager.buttons.pickSniper.center.add(Vector2.up.scale(16)),
            {
                align: "center",
                baseline: "bottom",
                color: this.engine.viewport.fColor
            }
        );

        let drawpos = GameManager.buttons.pickFighter.center.add(Vector2.up.scale(96+16));

        if (Physics.PointInRect(Input.mousePosition, GameManager.buttons.pickFighter)) {
            this.ctx.fillStyle = '#55ff55';
            this.engine.FillRectScreenFromCenter(drawpos, new Vector2(194, 194));
            this.ctx.fillStyle = 'black';
            this.engine.FillRectScreenFromCenter(drawpos, new Vector2(192, 192));
            this.ctx.fillStyle = '#55ff55';
            drawpos.y -= 94;
            this.engine.drawTexts([`Fighter`], drawpos, {align: 'center'});
            drawpos.x -= 94;
            drawpos.y += 16;
            this.engine.drawTexts([
                '- Twinfire Machine Guns',
                '- Homing Missiles',
            ], drawpos);

            drawpos.y += 64;
            this.engine.drawTextWrap('Afterburner Dash: Short burst of extreme speed to evade or close gaps.', drawpos, 192);
            drawpos.y += 32;
            this.engine.drawTextWrap('EMP: Emits a short-range electromagnetic pulse, temporarily disabling nearby enemy systems.', drawpos, 192);
            drawpos.y += 48;
            this.engine.drawTextWrap('Shield Overcharge: Temporarily increases shield durability by 50%.', drawpos, 192);

            drawpos = GameManager.buttons.pickFighter.center.add(Vector2.up.scale(192+6));
            drawpos.x += 96-10;

            this.DrawUiIcon(0, drawpos);
        }
        if (Physics.PointInRect(Input.mousePosition, GameManager.buttons.pickTank)) {
            this.ctx.fillStyle = '#55ff55';
            this.engine.FillRectScreenFromCenter(GameManager.buttons.pickTank.center.add(Vector2.up.scale(96+16)), new Vector2(194, 194));
            this.ctx.fillStyle = 'black';
            this.engine.FillRectScreenFromCenter(GameManager.buttons.pickTank.center.add(Vector2.up.scale(96+16)), new Vector2(192, 192));
            this.ctx.fillStyle = '#55ff55';
            drawpos = GameManager.buttons.pickTank.center.add(Vector2.up.scale(192+14));
            this.engine.drawTexts([`Tank`], drawpos, {align: 'center'});
            drawpos.x -= 94;
            drawpos.y += 16;
            this.engine.drawTexts([
                '- Heavy Cannon',
                '- Flak Disperser',
            ], drawpos);
            drawpos.y += 34+16;
            this.engine.drawTextWrap('Fortify: Activates reinforced armor, reducing incoming damage for a short time.', drawpos, 192);
            drawpos.y += 48;
            this.engine.drawTextWrap('Gravity Well: Deploys a field that pulls in nearby enemies.', drawpos, 192);
            drawpos.y += 32;
            this.engine.drawTextWrap('Countercharge: Reflects 20% of incoming damage back at attackers for a limited time.', drawpos, 192);

            drawpos = GameManager.buttons.pickTank.center.add(Vector2.up.scale(192+6));
            drawpos.x += 96-10;

            this.DrawUiIcon(1, drawpos);
        }
        if (Physics.PointInRect(Input.mousePosition, GameManager.buttons.pickSniper)) {
            // this.engine.FillRectScreenFromCenter(GameManager.buttons.pickSniper.center, GameManager.buttons.pickSniper.size.add(new Vector2(2, 2)));
            this.ctx.fillStyle = '#55ff55';
            this.engine.FillRectScreenFromCenter(GameManager.buttons.pickSniper.center.add(Vector2.up.scale(96+16)), new Vector2(194, 194));
            this.ctx.fillStyle = 'black';
            this.engine.FillRectScreenFromCenter(GameManager.buttons.pickSniper.center.add(Vector2.up.scale(96+16)), new Vector2(192, 192));
            this.ctx.fillStyle = '#55ff55';
            drawpos = GameManager.buttons.pickSniper.center.add(Vector2.up.scale(192+14));
            this.engine.drawTexts([`Sniper`], drawpos, {align: 'center'});
            drawpos.x -= 94;
            drawpos.y += 16;
            this.engine.drawTexts([
                '- Railgun',
                '- Dagger Mines',
            ], drawpos);
            drawpos.y += 34+16+14;
            this.engine.drawTextWrap('Cloaking Field: Temporarily turns invisible to reposition or escape.', drawpos, 192);
            drawpos.y += 32;
            this.engine.drawTextWrap('Target Lock: Highlights a specific target for allies.', drawpos, 192);
            drawpos.y += 32;
            this.engine.drawTextWrap('Overcharged Shot: Your next railgun shot fires a supercharged round with increased damage and penetration.', drawpos, 192);

            drawpos = GameManager.buttons.pickSniper.center.add(Vector2.up.scale(192+6));
            drawpos.x += 96-10;

            this.DrawUiIcon(2, drawpos);
        }
        if (Physics.PointInRect(Input.mousePosition, GameManager.buttons.pickScout)) {
            this.ctx.fillStyle = '#55ff55';
            this.engine.FillRectScreenFromCenter(GameManager.buttons.pickScout.center.add(Vector2.up.scale(96+16)), new Vector2(194, 194));
            this.ctx.fillStyle = 'black';
            this.engine.FillRectScreenFromCenter(GameManager.buttons.pickScout.center.add(Vector2.up.scale(96+16)), new Vector2(192, 192));
            this.ctx.fillStyle = '#55ff55';
            drawpos = GameManager.buttons.pickScout.center.add(Vector2.up.scale(192+14));
            this.engine.drawTexts([`Scout`], drawpos, {align: 'center'});
            drawpos.x -= 94;
            drawpos.y += 16;
            this.engine.drawTexts([
                '- Scatter Rifle',
                '- Disruptor Darts',
            ], drawpos);
            drawpos.y += 34+16+16+14;
            this.engine.drawTextWrap('Boost Thrusters: Gain a sustained speed increase for scouting or escaping.', drawpos, 192);
            drawpos.y += 32;
            this.engine.drawTextWrap('Sensor Sweep: Reveals enemy locations within a large radius for all teammates.', drawpos, 192);
            drawpos.y += 32;
            this.engine.drawTextWrap('Phase Shift: Creates an unstable rift you can warp back to for a short time.', drawpos, 192);

            drawpos = GameManager.buttons.pickScout.center.add(Vector2.up.scale(192+6));
            drawpos.x += 96-10;

            this.DrawUiIcon(3, drawpos);
        }
        if (Physics.PointInRect(Input.mousePosition, GameManager.buttons.pickHealer)) {
            this.ctx.fillStyle = '#55ff55';
            this.engine.FillRectScreenFromCenter(GameManager.buttons.pickHealer.center.add(Vector2.up.scale(96+16)), new Vector2(196, 196));
            this.ctx.fillStyle = 'black';
            this.engine.FillRectScreenFromCenter(GameManager.buttons.pickHealer.center.add(Vector2.up.scale(96+16)), new Vector2(192, 192));
            this.ctx.fillStyle = '#55ff55';
            drawpos = GameManager.buttons.pickHealer.center.add(Vector2.up.scale(192+14));
            this.engine.drawTexts([`Healer`], drawpos, {align: 'center'});
            drawpos.x -= 94;
            drawpos.y += 16;
            this.engine.drawTexts([
                '- Pulse Blaster',
                '- Repair Beam',
            ], drawpos);
            drawpos.y += 34+16+14;
            this.engine.drawTextWrap('Healing Field: Deploys an area-of-effect zone that gradually restores ally health.', drawpos, 192);
            drawpos.y += 32;
            this.engine.drawTextWrap('Energy Transfer: Sacrifices part of the Healer\'s shields to boost an ally\'s energy reserves.', drawpos, 192);
            drawpos.y += 48;
            this.engine.drawTextWrap('Emergency Shield Burst: Instantly restores a portion of all nearby allies\' shields.', drawpos, 192);

            drawpos = GameManager.buttons.pickHealer.center.add(Vector2.up.scale(192+6));
            drawpos.x += 96-10;

            this.DrawUiIcon(4, drawpos);
        }

        if (this.isHost) {
            this.ctx.fillStyle = '#55ff55';
            GameManager.buttons.startGame.center = new Vector2(winTopLeft.x + winSize.x/2, winTopLeft.y + winSize.y - 32);
            this.engine.FillRectScreenFromCenter(GameManager.buttons.startGame.center, GameManager.buttons.startGame.size);
            this.ctx.fillStyle = 'black';
            this.engine.FillRectScreenFromCenter(GameManager.buttons.startGame.center, GameManager.buttons.startGame.size.sub(new Vector2(2, 2)));
            this.engine.drawTexts(['Start Game'], GameManager.buttons.startGame.center, {
                align: 'center',
                baseline: 'middle',
                color: '#55ff55'
            });
        }
    }

    Draw(): void {
        
        switch (this.gameState) {
            case GameState.Lobby:
                this.DrawLobbyScreen();
                break;
            case GameState.InGame:
                this.DrawInGameScreen();
                break;
            case GameState.PostGame:
                this.DrawPostGameScreen();
                break;
        
            default:
                break;
        }

    }

}